import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../service/auth.service";
import { TranslocoService } from "@jsverse/transloco";
import { RestService, SidenavInterface } from "@stdoutsrl/design-kit";
import { api, environment } from "../../environments/environment";

@Component({
  selector: "app-pages",
  template: `<div *transloco="let t">
    <div class="dark h-screen w-screen bg-tertiary flex" *ngIf="logged">
      <std-sidenav
        [expanded]="isMenuOpen"
        childrenType="secondary"
        (onChangeExpanded)="menuChanged($event)"
        primaryColor="var(--primary)"
        secondaryColor="var(--secondary)"
        (menuClick)="goTo($event)"
        [showScrollbar]="false"
        [menuItems]="menuItems"
        textClass="text-white"
        closeMenuClass="text-primary"
        (userClick)="userClick()"
        [userInfo]="userInfo"
        [closeMenu]="t('closeMenu')"
        customIconClass="w-[65%]"
        mobileOpenMenuClass="top-[24px] left-[calc(100vw-48px)] hidden"
      >
        <div
          title
          class="text-[26px] h-[69px] pt-[30px] font-bold text-center text-white mx-[18px]"
        >
          <img class="w-[185px]" src="../assets/conad-logo.svg" />
        </div>
        <div
          subTitle
          class="text-[26px] h-[69px] pt-[30px] font-bold text-center text-white mx-[18px]"
        >
           <img class="w-[54px]" src="../assets/conad-min-logo.svg" />

        </div>
      </std-sidenav>
      <div class="w-full h-screen">
        <div class="h-20 bg-tertiary shadow-lg items-center pl-4 flex">
          <std-breadcrumb
            arrowUrl="../assets/chevron-back.svg"
            [breadcrumbs]="getBreadCrumb()"
            labelItemClass="text-primary"
            endpointClass="text-primary"
            [currentElement]="currentBreadcrumb"
          ></std-breadcrumb>
          <div
            (click)="changeMenu()"
            class="ml-auto flex h-8 mr-4 items-center md:hidden place-content-center rounded-full top-[24px] w-8"
            style="background: var(--primary);"
          >
            <svg
              height="20"
              width="20"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
              style="fill: white;"
            >
              <path
                d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"
              ></path>
            </svg>
          </div>
        </div>
        <div
          class="h-[calc(100vh-80px)] overflow-y-scroll hide-bar"
          [ngClass]="{
            'w-screen md:w-[calc(100vw-221px)]': isMenuOpen,
            'w-screen md:w-[calc(100vw-90px)]': !isMenuOpen
          }"
        >
          <router-outlet></router-outlet>
        </div>
      </div>
      <div class="hidden text-tertiary"></div>
    </div>
  </div> `,
  styles: [],
  standalone: false,
})
export class PagesComponent implements OnInit {
  constructor(
    private router: Router,
    private auth: AuthService,
    private translocoService: TranslocoService,
    private rest:RestService
  ) { }
  logged = false;
  currentBreadcrumb: any = null;
  userInfo = { username: "" };
  menuItems: SidenavInterface[] = [];
  isMenuOpen = window.innerWidth > 768;
  userData: any = {};

  ngOnInit(): void {
    if (localStorage.getItem("token")) {
      this.getMe();
    } else {
      localStorage.clear();
      window.location.replace("login");
    }
  }

  changeMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  menuChanged(menuExpanded: boolean) {
    this.isMenuOpen = menuExpanded;
  }

  getMe() {
    this.rest.get(api.endpoint.me).subscribe({
      next: (user:any) => {
        this.translocoService.selectTranslateObject("routes").subscribe((route) => {
          this.menuItems = [];
          if(user?.roleInfo?.name == 'ADMIN'){
          this.menuItems.push({
            text: 'Punti vendita',
            route: '/punti-vendita',
            iconUrl: "../assets/employee.svg",
          });}
          if(user?.roleInfo?.name == 'ADMIN'){
          this.menuItems.push({
            text: 'Lavori',
            route: '/lavori',
            iconUrl: "../assets/employee.svg",
          });}
          this.menuItems.push({
            text: route.employees.menu,
            route: route.employees.path,
            iconUrl: "../assets/employee.svg",
          });
          this.menuItems.push({
            text: 'Calendario',
            route: '/calendario-turni',
            iconUrl: "../assets/employee.svg",
          });
          this.menuItems.push({
            text: 'Lista turni', 
            route: '/calendario-migliore',
            iconUrl: "../assets/employee.svg",
          });
          this.menuItems.push({
            text: 'Resoconto',
            route: '/resoconto',
            iconUrl: "../assets/employee.svg",
          });
          if(user?.roleInfo?.name == 'ADMIN'){this.menuItems.push({
            text: 'Gestori',
            route: '/gestori',
            iconUrl: "../assets/employee.svg",
          });}
          this.logged = true;
          this.userInfo = {
            username: user.firstName + ' ' + user.lastName
          }
        });
      },
      error: () => {
        if (environment.testing) {
          this.translocoService.selectTranslateObject("routes").subscribe((route) => {
            this.menuItems = [];
            this.menuItems.push({
              text: 'Punti vendita',
              route: '/punti-vendita',
              iconUrl: "../assets/employee.svg",
            });
            this.menuItems.push({
              text: route.employees.menu,
              route: route.employees.path,
              iconUrl: "../assets/employee.svg",
            });
            this.menuItems.push({
              text: 'Calendario',
              route: '/calendario-turni',
              iconUrl: "../assets/employee.svg",
            });
            this.logged = true;
          });
        }
      },
    })
  }

  getBreadCrumb() {
    let breadcrumb: any =
      this.router.routerState?.root?.children[0]?.children[0];

    if (breadcrumb) {
      if (
        breadcrumb.data?._value?.currentElement ||
        breadcrumb.data?._value?.currentElement == 0
      ) {
        this.currentBreadcrumb = breadcrumb.data?._value?.currentElement;
      } else {
        this.currentBreadcrumb = null;
      }
      return breadcrumb.data?._value?.breadcrumb;
    } else {
      return [];
    }
  }

  goTo(menuItem: any) {
    this.router.navigate([menuItem.route]);
    if (window.innerWidth <= 768) {
      this.isMenuOpen = false;
    }
  }
  userClick() {
    this.translocoService.selectTranslateObject("routes").subscribe((route) => {
      this.router.navigate([route.userProfile.path]);
      this.logged = true;
    });
    if (window.innerWidth <= 768) {
      this.isMenuOpen = false;
    }
  }
}
